<template>
    <div
        id="site-search-panel"
        class="overview-panel v-flex"
        :key="count"
        v-resize="onResize"
    >
        <div style="margin-top: 12px; margin-left: 10px">
            <table id="site-table" class="table table-hover table-bordered">
                <thead>
                <tr class="table-header">
                    <th class="text-center" style="width: 30px">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "lmstate"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center" style="width: 30px">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "state"
                            v-model = "sort"
                        />
                    </th>

                    <th class="text-center" style="width: 30px">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "sitetype"
                            v-model = "sort"
                        />
                    </th>

                    <th class="text-center" style="width: 100px">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "fabricNo"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "customer"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first  ="city"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "street"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "ve"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "ve2"
                            v-model = "sort"
                        />
                    </th>
                    <th class="text-center">
                        <v-table-header-cell
                            group   ="msd.overview.header"
                            first   = "ve3"
                            v-model = "sort"
                        />
                    </th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net';
import tables           from '@/assets/js/tables'
import security         from '@/main'
import SearchRequest from "@/modules/core/service/private/SearchRequest";
import Core             from "@/modules/core/service/Core";
import VTableHeaderCell from "@/modules/core/components/utils/VTableHeaderCell";
import moment from "moment/moment";

const Const = {
    nl   : '<br>',
    na   : '-/-',
    table: {
        id         : '#site-table',
        url        : '/site',
        checkicon  : tables.css.icon.check,
        uncheckicon: tables.css.icon.uncheck,
    },
    format: {
        date: 'DD.MM.yyyy'
    }
};

export default {
    name: "MSiteTable",

    components: {
        VTableHeaderCell,
    },

    props: {
        customer: {

        },

        data: {


        },
    },

    data: () => ({
        table: null,
        pageLength: 22,
        count: 0,
        state: [
            "table-status-r",
            "table-status-y",
            "table-status-g"
        ],
        sort : {
            column: "fabricNo",
            dir   : "DESC"
        }
    }),

    watch: {
        sort: {
            handler: function () {
                this.onRefresh();
            },
            deep: true
        },

        data: {
            handler: function () {
                this.onRefresh();
            },
            deep: true
        },

        customer () {
            this.onRefresh();
        }
    },

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        columns () {
            const self = this;
            return [
                {
                    width: '30px',
                    class: 'text-center',
                    render: function (data, type, row) {
                        return self.lmstatus(row);
                    }
                },
                {
                    width: '30px',
                    class: 'text-center',
                    render: function (data, type, row) {
                        return self.status(row);
                    }
                },
                {
                    width: '30px',
                    class: 'text-center',
                    render: function (data, type, row) {
                        return self.type(row.type);
                    }
                },
                {
                    width: '170px',
                    render: function (data, type, row) {
                        return tables.line(row.fabricNo);
                    }
                },
                {
                    width: '15%',
                    render: function (data, type, row) {
                        return tables.line(row.customer.name);
                    }
                },
                {
                    width: '20%',
                    render(data, type, row) {
                        return tables.line(row.zip + ' ' + row.city);
                    }
                },
                {
                    width: '20%',
                    render(data, type, row) {
                        return tables.line(row.street);
                    }
                },

                {
                    width: '20%',
                    render: function (data, type, row) {
                        return tables.line(row.ve);
                    }
                },
                {
                    width: '20%',
                    render: function (data, type, row) {
                        return tables.line(row.ve2);
                    }
                },
                {
                    width: '20%',
                    render(data, type, row) {
                        return tables.line(row.ve3);
                    }
                },
            ]
        },
    },

    created() {
        this.$bus.$on(this.$events.filter, this.onRefresh);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.filter, this.onRefresh);
    },

    methods: {
        /**
         * Updates the display with the data from the given site. Only the data that is actually displayed will be
         * updated. This means that all other data remain unchanged and will be only updated with the next refresh.
         *
         * @param site the new site data.
         */
        refresh (site) {
            const data = this.table.api().rows().data();
            const count = data.count();

            let siteIndex = -1;
            for (let index=0; index < count; index ++) {
                if (data[index].id === site.id) {
                    siteIndex = index;
                    break;
                }
            }

            if (parseInt (siteIndex) >= 0) {
                const row = data[siteIndex];
                row.street = site.street;
                row.fabricNo = site.fabricNo;
                row.customer = site.customer;
                row.zip = site.zip;
                row.city = site.city;
                row.ve = site.ve;
                row.ve2 = site.ve2;
                row.ve3 = site.ve3;
                this.table.api().row(siteIndex).data(row);
            }
        },

        onRefresh () {
            if (this.data) {
                this.show(this.data.field, this.data.criteria, this.customer);
            } else if (this.customer || this.customer === 0) {
                this.show(null, null, this.customer);
            } else {
                this.show(null, null, -1);
            }
        },

        show(field, criteria, customer) {
            const self = this;

            $.fn.DataTable.ext.pager.numbers_length = 10;
            this.table = $(Const.table.id).dataTable({
                dom: 'Bfrtip',
                buttons: [
                    'csv',
                    'print'
                ],
                processing  : false,
                serverSide  : true,
                paging      : true,
                searching   : false,
                ordering    : false,
                info        : true,
                autoWidth   : false,
                lengthChange: false,
                deferRender : true,
                destroy     : true,
                idSrc       : 'id',
                rowId       : 'id',
                select      : true,
                pageLength  : self.pageLength,
                language    : tables.language(),
                infoCallback: function (settings, start, end, max, total) {
                    if (total === 0) return '';
                    return self.$t('site.pagination.info', [ start, end, total ]);
                },
                ajax        : {
                    headers : security.jsonHeader(),
                    dataType: 'json',
                    type    : 'POST',
                    url     : SearchRequest.url(Const.table.url),
                    data: function ( d ) {
                        const filter = {
                            value: criteria,
                            field: field,
                            onlyMyCustomers: true,
                            onlyLiftmanagement: false,
                            customer: customer || customer === 0 ? [ customer ] : [],
                        }

                        return JSON.stringify(SearchRequest.table(d, self.sort, SearchRequest.siteFilter(filter)));
                    },
                    dataSrc: 'data',
                    beforeSend: function () {
                        Core.loading(self, true);
                    },
                    complete: function () {
                        Core.loading(self, false);
                    },
                    error: function (xhr)
                    {
                        if (xhr.status === 401) {
                            security.logout();
                        }
                    }
                },
                drawCallback: function() {
                    $(Const.table.id).find('td').each (function () {
                        const text = $(this).text();
                        this.setAttribute( 'title', text);
                    });
                },
                columns: this.columns
            });

            self.table.on( 'click', 'tr', function () {
                const rowdata = self.table.api().row( $(this)).data();
                if (rowdata) {
                    self.$emit("selected", rowdata)
                }
            });
        },

        status (site) {
            let color = site.status && site.status.id === 1 ? 'green' : 'red';
            if (site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.expiration) {
                const today = moment ();
                const expiration = moment (site.liftmanagement.contract.expiration);
                if (today > expiration) {
                    color = "white";
                }
            } else {
                color = "white";
            }

            return $('<div>', { class: "v-flex h-100 ", style: "justify-content: center" })
                .append($('<div>', {class: "site-table-status " + color })).prop('outerHTML');
        },

        lmstatus (site) {
            if (!site.liftmanagement || !site.liftmanagement.contract || !site.liftmanagement.contract.active) {
                return null;
            }

            const name = site.liftmanagement.contract.type.id === 1 ? 'LIM' : 'DLS';

            return $('<div>', {
                    class: "v-flex h-100 site-table-lmstate",
                    style: "justify-content: center",
                    text : name
                }).prop('outerHTML');
        },

        type (type) {
            const sdiv = $('<div>', {
                html: $('<i>', {
                    class: 'v-icon notranslate mr-1 mdi primary--text ' + type.symbol,
                    style: 'font-size: 22px; margin-top: -1px;',
                    title: type.name
                })
            });

            return sdiv.html();
        },

        onResize () {
            const height = window.innerHeight - 180;
            const rows = (height / 39) | 0;
            if (rows !== this.pageLength) {
                this.pageLength = rows;
                this.onRefresh ();
            }
        }
    }
}
</script>

<style scoped>

::v-deep .dt-buttons {
    display: none;
}

::v-deep .site-table-status {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    border-radius: 2px;
}

::v-deep .site-table-lmstate {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    border-radius: 2px;
}

</style>